import React, { useContext } from "react";
import { useEffect } from "react";
import Compact from "../subsystems/Compact";
import CompactNew from "../subsystems/CompactNew";
import EndColumns from "../subsystems/EndColumns";
import CapellaBottom from "../subsystems/CapellaBottom";
import * as constant from "../utils/constant";
import state from "../state";
import { useSnapshot } from "valtio";
import FixedGlass from "../subsystems/FixedGlass";
import FixedWall from "../subsystems/FixedWall";
import Minima from "../subsystems/Minima";
import Classy from "../subsystems/Classy";
import Door from "../subsystems/Door";
import LiftAndSlideDoor from "../subsystems/LiftAndSlideDoor";
import Forte from "../subsystems/Forte";
import Zion from "../subsystems/Zion";
import CapellaOne from "../subsystems/CapellaOne";
import BifoldDoorOne from "../subsystems/BifoldDoorOne";
import Loader3d from "../common/Loading/Loader3d";
import AppContext from "context/AppContext";

function Init(modelID, unit, systemID) {
  state.flag = true;
  state.isDesign = null;
  state.isTexture = false;
  state.isBladeTexture = false;
  state.designStyle = null;
  state.hasLight = false;
  state.blades = {
    color: constant.coverColors[modelID][0].color,
    texture: constant.wooddesign[modelID][0].url,
    textureType: "Frosted",
    rotation: 0,
    opacity: 1,
    colorName: constant.coverColors[modelID][0].title,
  };
  state.structure = {
    color: constant.coverColors[modelID][0].color,
    texture: constant.wooddesign[1][0].url,
    textureA: constant.wooddesign[1][0].url2,
    textureB: constant.wooddesign[1][0].url2,
    textureC: constant.wooddesign[1][0].url2,
    textureD: constant.wooddesign[1][0].url2,
    textureR: constant.wooddesign[1][0].url2,
    colorName: constant.coverColors[modelID][0].title,
  };
  state.length = {
    unit: unit === "inch" ? 1 / 25.4 : 1,
    unitName: unit,
    width: constant.subsystem_lengths[systemID].default_width,
    depth: constant.subsystem_lengths[systemID].default_height,
    height1: 3000,
    height2: 3000,
  };

  state.default_width = constant.subsystem_lengths[systemID].default_width;
  state.default_depth = constant.subsystem_lengths[systemID].default_height;
  state.columns = {
    count: 0,
    adding: false,
    addingSubSystem: false,
    editing: false,
    editingColumn: null,
    editingSide: 0,
    minPos: 500,
    maxPos: 2100,
    direction: [
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
    ],
    removable: [
      false,
      false,
      false,
      false,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
    ],
    added: [
      true,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ],
    addedSubSystem: [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ],
    deletedSubSystem: [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ],
    subSystemCount: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    systemPos: [
      systemID === 8 ? 10 : 0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
    ],
    systemDirection: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    systemId: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    systemLock: [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ],
    addedForte: [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ],
    fortePos: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    pos: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    side: [
      1, 2, 3, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    isShift: [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ],
  };
  state.walls = {
    adding: false,
    added: [false, false, false, false],
    addingSide: 0,
  };
  state.datasent = 0;
  state.responseMsg = "";
  state.isModel = false;
  state.isSubSystem = true;
  state.systemID = systemID;
}

export default function CompactApp(props) {
  const { mode, setShowprice } = useContext(AppContext);
  const snap = useSnapshot(state);
  const user =
    mode === 0
      ? JSON.parse(localStorage.getItem("user")).user
      : localStorage.getItem("embed_user")
      ? JSON.parse(localStorage.getItem("embed_user"))
      : null;
  const [status, setStatus] = React.useState(false);
  if (mode === 0 && user.brand_color !== null && user.brand_color !== "null")
    props.setBrandColor(user.brand_color);
  if (mode === 1)
    setShowprice(
      JSON.parse(localStorage.getItem("embed_user")).showprice === 1 ? 1 : 0
    );
  // const unit = localStorage.getItem('unit') === null?'inch':localStorage.getItem('unit');
  const unit =
    !user.unit || user.unit === null ? "inch" : user.unit == 0 ? "inch" : "mm";
  localStorage.setItem("unit", unit);

  useEffect(() => {
    Init(0, unit, props.systemID);
    props.setSystemID(props.systemID);
    props.setModelID(0);
    state.columns.systemId[0] = props.systemID;
    setStatus(true);
  }, []);

  const render = (systemID) => {
    switch (systemID) {
      case 0:
        return (
          <CompactNew
            scale={0.01}
            px={0}
            py={-1.5}
            pz={0}
            rotation={[-Math.PI / 2, 0, Math.PI]}
            unit={0.1}
            ID={0}
            modelID={0}
            systemID={systemID}
            width={snap.length.width}
            height={snap.length.depth}
            group={props.group}
            systemType={1}
            isTexture={snap.isTexture}
            texture={snap.structure.texture}
          />
        );
      case 1:
        return (
          <Classy
            scale={0.01}
            px={0}
            py={-1.5}
            pz={-0.47}
            rotation={[-Math.PI / 2, 0, Math.PI]}
            unit={0.1}
            ID={0}
            modelID={0}
            systemID={systemID}
            width={snap.length.width}
            height={snap.length.depth}
            group={props.group}
            systemType={1}
            isTexture={snap.isTexture}
            texture={snap.structure.texture}
          />
        );
      case 2:
        return (
          <Minima
            scale={0.01}
            px={0}
            py={-1.5}
            pz={-0.47}
            rotation={[-Math.PI / 2, 0, Math.PI]}
            unit={0.1}
            ID={0}
            modelID={0}
            systemID={systemID}
            width={snap.length.width}
            height={snap.length.depth}
            group={props.group}
            systemType={1}
            isTexture={snap.isTexture}
            texture={snap.structure.texture}
          />
        );
      case 3:
        return (
          <FixedGlass
            scale={0.01}
            px={0}
            py={-1.5}
            pz={-0.47}
            rotation={[-Math.PI / 2, 0, Math.PI]}
            unit={0.1}
            ID={0}
            modelID={0}
            systemID={systemID}
            width={snap.length.width}
            height={snap.length.depth}
            group={props.group}
            systemType={1}
            isTexture={snap.isTexture}
            texture={snap.structure.texture}
          />
        );
      case 4:
        return (
          <FixedWall
            scale={0.01}
            px={0}
            py={-1.5}
            pz={-0.47}
            rotation={[-Math.PI / 2, 0, Math.PI]}
            unit={0.1}
            ID={0}
            modelID={0}
            systemID={systemID}
            width={snap.length.width}
            height={snap.length.depth}
            group={props.group}
            sytemType={1}
            isTexture={snap.isTexture}
            texture={snap.structure.texture}
          />
        );
      case 5:
        return (
          <LiftAndSlideDoor
            scale={0.01}
            px={0}
            py={-1.5}
            pz={-0.47}
            rotation={[-Math.PI / 2, 0, Math.PI]}
            unit={0.1}
            ID={0}
            modelID={0}
            systemID={systemID}
            width={snap.length.width}
            height={snap.length.depth}
            group={props.group}
            systemType={1}
            isTexture={snap.isTexture}
            texture={snap.structure.texture}
          />
        );
      case 6:
        return (
          <Forte
            scale={0.01}
            px={0}
            py={-1.5}
            pz={-0.47}
            rotation={[-Math.PI / 2, 0, Math.PI]}
            unit={0.1}
            ID={0}
            modelID={0}
            systemID={systemID}
            width={snap.length.width}
            height={snap.length.depth}
            group={props.group}
            systemType={1}
            isTexture={snap.isTexture}
            texture={snap.structure.texture}
          />
        );
      case 7:
        return (
          <Zion
            scale={0.01}
            px={0}
            py={-1.5}
            pz={-0.47}
            rotation={[-Math.PI / 2, 0, Math.PI]}
            unit={0.1}
            ID={0}
            modelID={0}
            systemID={systemID}
            width={snap.length.width}
            height={snap.length.depth}
            group={props.group}
            systemType={1}
            isTexture={snap.isTexture}
            texture={constant.wooddesign[0][0].url}
          />
        );
      case 8:
        return (
          <BifoldDoorOne
            scale={0.01}
            px={0}
            py={-1.5}
            pz={-0.47}
            rotation={[-Math.PI / 2, 0, Math.PI]}
            unit={0.1}
            ID={0}
            modelID={0}
            systemID={systemID}
            width={snap.length.width}
            height={snap.length.depth}
            group={props.group}
            systemType={1}
            isTexture={snap.isTexture}
            texture={snap.structure.texture}
          />
        );
      case 9:
        return (
          <CapellaOne
            int_length={constant.lengths[2]}
            modelID={2}
            length={snap.length}
            scale={0.01}
            px={0}
            py={-1.5}
            pz={-0.47}
            rotation={[-Math.PI / 2, 0, Math.PI]}
            unit={0.1}
            ID={0}
            systemID={systemID}
            width={snap.length.width}
            height={snap.length.depth}
            group={props.group}
            systemType={1}
            isTexture={snap.isTexture}
            texture={snap.structure.texture}
          />
        );

      default:
        return null;
    }
  };

  const bias = [0, -0.2, -0.2, -0.5, -0.5, 0, -0.5, -0.5, 0.2, -0.25, -0.2];

  return snap.flag && status ? (
    <group
      position={[
        ((constant.subsystem_lengths[props.systemID].default_width -
          snap.length.width) *
          0.0005) /
          2 +
          bias[props.systemID],
        -0.4,
        0,
      ]}
      scale={0.5}
    >
      <group rotation={[0, Math.PI / 2, 0]}>
        {render(props.systemID)}
        {/* {props.systemID == 9 && false?
        <EndColumns
            scale={0.01} 
            px={0.08}
            py={-1.6}
            pz={0.1}
            rotation={[0, Math.PI / 2, 0]}
            unit={0.1} 
            width={snap.length.width} 
            height = {snap.length.depth}
            group={props.group}
            systemID={props.systemID}  
          />:null} */}
        {props.systemID === 9 ? (
          <CapellaBottom width={snap.length.width} depth={snap.length.depth} />
        ) : null}
      </group>
    </group>
  ) : (
    <Loader3d />
  );
}
